var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBg6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1875,
    height: 1552,
    viewBox: "0 0 1875 1552",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25987_49731)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1874.36 0H0V1551.73H1874.36V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.351 384.469C639.974 359.908 670.116 350.23 694.677 362.853L1404.1 727.448C1428.67 740.07 1438.34 770.213 1425.72 794.774L1247.23 1142.08C1234.61 1166.64 1204.58 1176.38 1180.02 1163.76C1102.87 1124.12 941.142 1041.02 825.471 981.532C710.046 922.171 547.739 838.775 470.381 799.032C445.816 786.411 436.244 756.321 448.868 731.758L627.351 384.469Z",
    fill: "url(#paint0_linear_25987_49731)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25987_49731",
    x1: 1400.5,
    y1: 1086,
    x2: 812.529,
    y2: 399.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6F3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F8FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25987_49731"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1875,
    height: 1552,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg6);
export default __webpack_public_path__ + "static/media/bg-6.518c049850c2deda4ab3d4c193af0328.svg";
export { ForwardRef as ReactComponent };